import React from 'react';
import { FadeIn } from './FadeIn';
export function Hook() {
  return <section className="py-24 px-6 bg-cream" data-id="element-114">
      <div className="max-w-3xl mx-auto text-center" data-id="element-115">
        <FadeIn data-id="element-116">
          <p className="text-2xl md:text-3xl font-serif text-teal leading-relaxed mb-8" data-id="element-117">
            You’re staring at the clock again. It’s 3:14 AM. You’re damp with
            sweat, your heart is racing, and your hips have that familiar, angry
            throb that makes it impossible to get back to sleep.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-118">
          <p className="text-lg md:text-xl text-charcoal/80 leading-relaxed" data-id="element-119">
            You feel like a stranger in your own skin. You were told menopause
            was just "a few hot flashes," but nobody warned you about the
            bone-deep exhaustion or the sudden joint pain that makes you feel
            twenty years older than you actually are.
          </p>
        </FadeIn>
      </div>
    </section>;
}